/**
 * This file is repsonsible for defining a hook that is used in place of an onScroll event,
 * but throttles it so it isn't called an absurd amount of times.
 *
 * @todo this should be moved into the common hooks folder
 */

import { useState, useEffect } from 'react';
import { throttle } from 'lodash';

/* Basic scroll utility function scaffolding */
function useDocumentScrollThrottled(callback) {
  const [, setScrollPosition] = useState(0);

  useEffect(() => {
    function handleDocumentScroll() {
      const { scrollTop: currentScrollTop } = document.documentElement || document.body;

      setScrollPosition(() => {
        callback({ currentScrollTop });
        return currentScrollTop;
      });
    }

    const handleDocumentScrollThrottled = throttle(handleDocumentScroll, 250);

    window.addEventListener('scroll', handleDocumentScrollThrottled);

    return () => window.removeEventListener('scroll', handleDocumentScrollThrottled);
  }, [callback]);
}

export default useDocumentScrollThrottled;
